import styled, { css } from "styled-components";
import { spaceEnhancer } from "./spaceEnhancer";
import { alignItems, justifyContent } from "../core/enhancers";
export var Space = styled.div.withConfig({
  displayName: "Space",
  componentId: "sc-69m3bo-0"
})(function (_ref) {
  var theme = _ref.theme,
      gap = _ref.gap,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "row" : _ref$direction,
      align = _ref.align,
      justify = _ref.justify;
  return css(["display:flex;", ";", ";", ";"], alignItems({
    theme: theme,
    alignItems: align
  }), justifyContent({
    theme: theme,
    justifyContent: justify
  }), spaceEnhancer({
    theme: theme,
    gap: gap,
    direction: direction
  }));
});